import { useState } from 'react';
import { Box, useMediaQuery, useTheme, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import AppBarComponent from './AppBarComponent';
import DrawerComponent from './DrawerComponent';
import BottomNavigationComponent from './BottomNavigationComponent';
import Breadcrumbs from './Breadcrumbs';

const drawerWidth = 240;

function AppLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <AppBarComponent
        drawerWidth={drawerWidth}
        onMenuClick={handleDrawerToggle}
      />
      <DrawerComponent
        drawerWidth={drawerWidth}
        mobileOpen={mobileOpen}
        onDrawerToggle={handleDrawerToggle}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          mt: ['56px', '64px'],
          mb: isMobile ? '56px' : 0,
        }}
      >
        <Container maxWidth="xl">
          <Breadcrumbs />
          <Outlet />
        </Container>
      </Box>
      {isMobile && <BottomNavigationComponent />}
    </Box>
  );
}

export default AppLayout;
